import api from 'apis/config/api-service';

interface Category {
  id?: string | number;
  [key: string]: any;
}

interface CategoryParams {
  [key: string]: any;
}

export default {
  getCategories: (params?: CategoryParams) => api.get('categories', { ...params }),
  getCategoryById: (id: string | number, params?: CategoryParams) => api.get(`categories/${id}`, { ...params }),
  addOrUpdateCategory: (data: Category) =>
    data.id ? api.patch(`categories/${data.id}`, data) : api.post('categories', data),
};
